import { render, staticRenderFns } from "./purchaseHistory.vue?vue&type=template&id=555fbc42&scoped=true&"
import script from "./purchaseHistory.vue?vue&type=script&lang=js&"
export * from "./purchaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./purchaseHistory.vue?vue&type=style&index=0&id=555fbc42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555fbc42",
  null
  
)

export default component.exports